module.exports = __webpack_public_path__ + "static/media/overview2_0.9390abe3.png";